<template>
    <div :class="classes">
        <slot name="label">
            <v-label
                :labelFor="labelFor"
                :required="required"
                v-if="fieldLabel"
            >
                {{ fieldLabel }} {{ optionalFieldLabelSuffix }}

                <tooltip v-if="tooltip" position="right" :tooltipClasses="''">
                    <template #label>
                        <img class="information-icon" src="/imgs/icons/info_icon.svg"
                        />
                    </template>

                    <template #tooltip>
                        {{ tooltip }}
                    </template>
                </tooltip>
            </v-label>
        </slot>

        <slot name="field" />

        <span
            :dusk="`${labelFor}-error`"
            class="invalid-feedback"
            role="alert"
            v-if="error"
        >
            <strong>{{ error }}</strong>
        </span>
    </div>
</template>

<script>
import Tooltip from '../Tooltip';

export default {
    name: "DefaultField",
    components: {
        Tooltip
    },
    props: {
        labelFor: {
            type: String,
            default: ""
        },
        fieldLabel: {
            type: String,
            default: ""
        },
        optionalFieldLabelSuffix: {
            type: String,
            default: ""
        },
        tooltip: {
            type: String,
            default: null
        },
        classes: {
            type: String,
            default: "form__group"
        },
        error: {
            type: String,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        }
    }
};
</script>
